<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-alert text color="red" v-if="!!error">
          Palvelintarjoajan palveluissa on tällä hetkellä häiriöitä, jotka
          vaikuttavat myös tämän sivun toimintaan
        </v-alert>
        <v-alert text color="red" v-if="!!error">
          <b>Sivusto ei toimi järjestelmävirheen vuoksi</b> Ilmoita tästä
          sähköpostilla osoitteeseen vili@pysykotona.fi !
        </v-alert>
      </v-col>
      <v-col cols="12" sm="6" md="3" v-for="(c, i) in catInfo" :key="i">
        <v-btn
          large
          block
          :dark="!error"
          color="green"
          :disabled="!!error"
          :to="`/kategoria/${c.slug}`"
          :loading="loading"
        >
          <div class="title">{{ c.name }}</div>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'GlobalNav',
  data: () => ({
    error: false,
    catInfo: [
      { name: '🍽 Ruokaa', slug: 'ruokaa' },
      { name: '👚 Tuotteita', slug: 'tuotteita' },
      { name: '🧺 Palveluita', slug: 'palveluita' },
      { name: '🚕 Taksit', slug: 'taksit' }
    ],
    loading: true
  }),
  mounted() {
    fetch('https://hallinta.kotona.kiuruvesi.net/fontend/catInfo')
      .then(res => res.json())
      .then(res => (this.catInfo = { ...res }))
      .catch(err => (this.error = err))
      .finally(() => (this.loading = false))
  }
}
</script>
